// extracted by mini-css-extract-plugin
module.exports = {"container":"swish_container__JK6UG","article":"swish_article__NwHGU","campaign":"swish_campaign__QVkgq"};